export const ta = {
  'ad.label': 'விளம்பரம்',
  'ad.sponsored_by': '{advertiser} வழங்கியது',
  'ad.visit': 'பார்வையிடு',
  'cookies.preferences': 'குக்கீ விருப்பங்கள்',
  'cookies.title': 'உங்கள் தனியுரிமை, உங்கள் கட்டுப்பாட்டில்',
  'cookies.description': 'Albambam செயல்பட தேவையான சேமிப்பைப் பயன்படுத்துகிறோம். உங்கள் அனுமதியுடன் மட்டுமே பகுப்பாய்வு அல்லது சந்தைப்படுத்தலை இயக்குகிறோம். எப்போது வேண்டுமானாலும் அதைத் திரும்பப் பெறலாம். படிக்கவும்:',
  'cookies.privacy_link': 'தனியுரிமைக் கொள்கை',
  'cookies.close': 'விருப்பங்களை மூடு',
  'cookies.necessary': 'தேவையானவை',
  'cookies.necessary_desc': 'அமர்வு, பாதுகாப்பு, மொழி மற்றும் அடிப்படை விருப்பங்கள்.',
  'cookies.analytics': 'பகுப்பாய்வு',
  'cookies.analytics_desc': 'சேவையை மேம்படுத்த அநாமதேய பயன்பாட்டு அளவீடு.',
  'cookies.marketing': 'சந்தைப்படுத்தல்',
  'cookies.marketing_desc': 'விளம்பர தனிப்பயனாக்கம் மற்றும் பிரச்சார அளவீடு.',
  'cookies.configure': 'கட்டமை',
  'cookies.reject': 'விருப்பமானவற்றை நிராகரி',
  'cookies.save': 'தேர்வை சேமி',
  'cookies.accept': 'அனைத்தையும் ஏற்றுக்கொள்',
  'lang.selector_label': 'மொழி',
  'lang.changed': 'மொழி மாற்றப்பட்டது',
  'nav.home': 'முகப்பு',
  'nav.categories': 'பிரிவுகள்',
  'nav.shorts': 'ஷார்ட்ஸ்',
  'nav.friends': 'நட்பு',
  'nav.upload': 'பதிவேற்று',
  'nav.profile': 'சுயவிவரம்',
  'nav.login': 'உள்நுழை',
  'common.signed_in': 'உள்நுழைந்தீர்கள்',
  'common.error': 'பிழை',
  'topbar.search_placeholder': 'வீடியோக்கள், உருவாக்குநர்களைத் தேடுங்கள்...',
  'legal.terms': 'விதிமுறைகள்',
  'legal.privacy': 'தனியுரிமை',
  'nav.admin': 'நிர்வாகம்',
  'nav.logout': 'வெளியேறு',
  'admin.tab.payments': 'கட்டணங்கள்',
  'admin.payments.title': 'கட்டணங்கள்',
  'cats.title': 'பிரிவுகள்',
  'cats.all': 'அனைத்தும்',
  'cats.adult_title': '18+ பிரிவுகள்',
  'cats.empty': 'இந்தப் பிரிவில் வீடியோக்கள் இல்லை.',
  'friends.block_confirm': 'இந்த நண்பரைத் தடுக்கவா? இனி அரட்டை அடிக்கவோ அல்லது ஒருவருக்கொருவர் நண்பர்களாகப் பார்க்கவோ முடியாது.',
  'friends.accepted': 'இப்போது நீங்கள் நண்பர்கள்!',
  'friends.title': 'நட்பு',
  'friends.subtitle': 'ஒருவரையொருவர் பின்தொடர்பவர்கள் மட்டுமே நண்பர்களாகி தனிப்பட்ட முறையில் அரட்டை அடிக்க முடியும்.',
  'friends.unread_count_label': 'படிக்க {n} செய்திகள்',
  'friends.blocked_users_title': 'தடுக்கப்பட்ட பயனர்கள்',
  'friends.unblock_user': 'தடையை நீக்கு',
  'friends.requests_title': 'அரட்டை கோரிக்கைகள்',
  'friends.request_badge': 'கோரிக்கை',
  'friends.request_accept': 'ஏற்றுக்கொள்',
  'friends.request_ignore': 'புறக்கணி',
  'friends.empty_title': 'இன்னும் நண்பர்கள் இல்லை',
  'friends.empty_subtitle': 'யாரையாவது பின்தொடர்ந்து, அவர்களும் உங்களைப் பின்தொடர்ந்தால் தனிப்பட்ட அரட்டை திறக்கும்.',
  'friends.attach_image': 'புகைப்படம்',
  'friends.shared_video_label': 'ஒரு வீடியோவைப் பகிர்ந்தார்',
  'friends.select_conversation': 'அரட்டையைத் தொடங்க ஒரு நண்பரைத் தேர்ந்தெடுக்கவும்',
  'friends.block_user': 'தடு',
  'friends.no_messages_yet': 'இன்னும் செய்திகள் இல்லை. வணக்கம் சொல்லுங்கள்!',
  'friends.message_placeholder': 'ஒரு செய்தியை எழுதுங்கள்...',
  'section.trending': 'ட்ரெண்டிங்',
  'section.shorts': 'ஷார்ட்ஸ்',
  'section.for_you': 'உங்களுக்காக',
  'home.hero.badge': 'Albambam-க்கு வரவேற்கிறோம்',
  'home.hero.title_1': 'குறும் வீடியோக்கள்.',
  'home.hero.title_2': 'உண்மையான உருவாக்குநர்கள்.',
  'home.hero.subtitle': 'பாருங்கள், பகிருங்கள், சம்பாதியுங்கள். உங்கள் வீடியோக்களைப் பதிவேற்றி, ஒவ்வொரு பிரிவிலும் புதிய திறமைகளைக் கண்டறியுங்கள்.',
  'home.hero.cta_shorts': 'ஷார்ட்ஸ் பார்க்க',
  'home.hero.cta_trending': 'ட்ரெண்டிங்',
  'home.shorts.see_all': 'அனைத்தையும் பார்க்க',
  'home.empty.title': 'இன்னும் வீடியோக்கள் இல்லை',
  'home.empty.subtitle': 'உருவாக்குநர்கள் உள்ளடக்கத்தைப் பதிவேற்றும்போது, அது இங்கே தோன்றும்.',
  'live.send_diamonds': 'வைரங்களை அனுப்பு',
  'live.buy': 'வாங்கு',
  'live.chat': 'அரட்டை',
  'live.type_message': 'ஒரு செய்தியைத் தட்டச்சு செய்யவும்...',
  'live.send': 'அனுப்பு',
  'auth.success_google': 'Google மூலம் உள்நுழைந்தீர்கள்',
  'auth.fail_google': 'தவறான Google அமர்வு',
  'auth.success_login': 'உள்நுழைந்தீர்கள்',
  'auth.success_register': 'கணக்கு உருவாக்கப்பட்டது',
  'auth.login_tab': 'உள்நுழைவு',
  'auth.register_tab': 'கணக்கு உருவாக்கு',
  'auth.email': 'மின்னஞ்சல்',
  'auth.password': 'கடவுச்சொல்',
  'auth.submit_login_loading': 'உள்நுழைகிறது...',
  'auth.submit_login': 'உள்நுழை',
  'auth.name': 'பெயர்',
  'auth.submit_register_loading': 'உருவாக்கப்படுகிறது...',
  'auth.submit_register': 'கணக்கு உருவாக்கு',
  'auth.or': 'அல்லது',
  'legal.privacy_title': 'தனியுரிமைக் கொள்கை',
  'search.title': '\u201c{q}\u201dக்கான முடிவுகள்',
  'search.count': '{n} வீடியோக்கள்',
  'search.empty': 'முடிவுகள் இல்லை.',
  'series.load_error': 'தொடரை ஏற்ற முடியவில்லை',
  'series.unlocked': 'தொடர் திறக்கப்பட்டது',
  'series.purchase_error': 'கொள்முதலைத் தொடங்க முடியவில்லை',
  'series.restricted': 'கட்டுப்படுத்தப்பட்ட அணுகல்',
  'series.configure_access': 'அணுகலைக் கட்டமை',
  'series.language_all': 'அனைத்து மொழிகள்',
  'series.episode_count': '{n} அத்தியாயங்கள்',
  'series.buy': 'தொடரை வாங்கு',
  'series.filter_language': 'மொழி வாரியாக வடிகட்டு',
  'series.no_episodes': 'இன்னும் அத்தியாயங்கள் வெளியிடப்படவில்லை.',
  'series.episode_number': 'அத்தியாயம் {n}',
  'legal.terms_title': 'விதிமுறைகளும் நிபந்தனைகளும்',
  'lang.ca': 'காட்டலான்',
  'lang.en': 'ஆங்கிலம்',
  'lang.es': 'ஸ்பானியம்',
  'lang.fr': 'பிரெஞ்சு',
  'lang.de': 'ஜெர்மன்',
  'lang.it': 'இத்தாலியம்',
  'lang.eu': 'பாஸ்க்',
  'lang.gl': 'காலிசியம்',
  'lang.zh': 'சீனம்',
  'lang.other': 'மற்றவை',
  'lang.vi': 'வியட்னாமியம்',
  'lang.ja': 'ஜப்பானியம்',
  'lang.ko': 'கொரியம்',
  'lang.ru': 'ரஷ்யம்',
  'lang.ro': 'ருமேனியம்',
  'lang.ar': 'அரபு',
  'lang.tr': 'துருக்கியம்',
  'lang.pl': 'போலியம்',
  'lang.ms': 'மலாய்',
  'lang.ta': 'தமிழ்',
  'upload.series_title_error': 'தொடரின் தலைப்பை உள்ளிடவும்',
  'upload.series_adult_category_error': 'தொடருக்கு 18+ பிரிவைத் தேர்ந்தெடுக்கவும்',
  'upload.series_created': 'தொடர் உருவாக்கப்பட்டது',
  'upload.series_create_error': 'தொடரை உருவாக்க முடியவில்லை',
  'upload.err_file': 'சரியான வீடியோ கோப்பைத் தேர்ந்தெடுக்கவும்',
  'upload.err_title': 'தலைப்பை அமைக்கவும்',
  'upload.series_select_error': 'தொடரைத் தேர்ந்தெடுக்கவும் அல்லது உருவாக்கவும்',
  'upload.trailer_target_error': 'டிரெய்லர் வீடியோ அல்லது தொடரைத் தேர்ந்தெடுக்கவும்',
  'upload.price_error': 'குறைந்தது EUR 0.50 செல்லுபடியாகும் விலையை உள்ளிடவும்.',
  'upload.adult_category_error': 'வயதுவந்தோர் பிரிவைத் தேர்ந்தெடுக்கவும்',
  'upload.success': 'வீடியோ பதிவேற்றப்பட்டது',
  'upload.title_h': 'வீடியோவைப் பதிவேற்று',
  'upload.kind': 'இடுகை வகை',
  'upload.kind_video': 'தனி வீடியோ',
  'upload.kind_episode': 'தொடர் அத்தியாயம்',
  'upload.kind_trailer': 'பொது ஷார்ட்ஸ் டிரெய்லர்',
  'upload.series': 'தொடர்',
  'upload.series_select': 'தொடரைத் தேர்ந்தெடுக்கவும்',
  'upload.episode': 'அத்தியாயம்',
  'upload.series_new_title': 'புதிய தொடர் தலைப்பு',
  'upload.series_create': 'தொடரை உருவாக்கு',
  'upload.series_adult': '18+ தொடர்',
  'upload.series_premium': 'பிரீமியம் தொடர்',
  'upload.series_adult_category': 'தொடர் 18+ பிரிவு',
  'upload.series_price': 'அத்தியாயம் & தொகுப்பு விலை (EUR)',
  'upload.trailer_for': 'டிரெய்லர் இதனை வழங்குகிறது',
  'upload.trailer_select': 'வீடியோ அல்லது தொடரைத் தேர்ந்தெடுக்கவும்',
  'upload.video_prefix': 'வீடியோ',
  'upload.file_label': 'வீடியோ கோப்பு (MP4, அதிகபட்சம் 1GB)',
  'upload.file_pick': 'வீடியோவைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்',
  'upload.thumb_label': 'சிறுபடம் (விருப்பத்திற்குரியது)',
  'upload.video_title': 'தலைப்பு',
  'upload.description': 'விளக்கம்',
  'upload.category': 'பிரிவு',
  'upload.is_short': 'ஷார்ட்ஸ் (செங்குத்து)',
  'upload.paid_video': 'கட்டண வீடியோ',
  'upload.adult_content': '18+ உள்ளடக்கம்',
  'upload.video_language': 'வீடியோ மொழி',
  'upload.individual_price': 'இந்த வீடியோவைப் பார்க்க விலை (EUR)',
  'upload.paid_video_help': 'பார்வையாளர் இந்த வீடியோவிற்கு மட்டும் நிரந்தர அணுகலை வாங்குகிறார். குறைந்தபட்ச விலை EUR 0.50.',
  'upload.adult_category': 'வயதுவந்தோர் பிரிவு',
  'upload.uploading': 'பதிவேற்றம் {n}%',
  'upload.submit': 'வீடியோவைப் பதிவேற்று',
  'user.followers': 'பின்தொடர்பவர்கள்',
  'user.following': 'பின்தொடர்கிறார்கள்',
  'user.follow': 'பின்தொடர்',
  'user.chat_open': 'அரட்டை',
  'user.request_sent': 'கோரிக்கை அனுப்பப்பட்டது',
  'user.send_message': 'செய்தி அனுப்பு',
  'user.followers_title': 'பின்தொடர்பவர்கள்',
  'user.following_title': 'பின்தொடர்பவர்கள்',
  'user.unfollow': 'பின்தொடர்பை நீக்கு',
  'user.request_title': 'அரட்டை கோரிக்கை',
  'user.request_subtitle': 'நீங்கள் ஒரு செய்தி மட்டுமே அனுப்ப முடியும். அவர்கள் உங்கள் கோரிக்கையை ஏற்றால், நீங்கள் நண்பர்களாகி அரட்டை அடிக்கலாம்.',
  'user.request_placeholder': 'உங்கள் செய்தியை எழுதுங்கள்...',
  'user.request_send': 'கோரிக்கை அனுப்பு',
  'shorts.login_for_like': 'விருப்பம் தெரிவிக்க உள்நுழையவும்',
  'watch.share_copied': 'இணைப்பு நகலாக்கப்பட்டது',
  'watch.delete_confirm': 'இந்தக் கருத்தை நீக்கவா?',
  'ad.skip_in': '{n} வினாடிகளில் தவிர்',
  'ad.skip': 'விளம்பரத்தைத் தவிர்',
  'watch.share': 'பகிர்',
  'friends.share_video': 'வீடியோவைப் பகிர்',
  'friends.send': 'அனுப்பு',
  'watch.comments': 'கருத்துக்கள்',
  'watch.write_comment': 'கருத்தை எழுதுங்கள்...',
  'watch.publish': 'வெளியிடு',
  'watch.login_to_comment': 'கருத்திட உள்நுழையவும்.',
  'watch.login_btn': 'கருத்திட உள்நுழை',
  'watch.no_comments': 'இன்னும் கருத்துக்கள் இல்லை.',
  'watch.related': 'தொடர்புடையவை',
  'nav.trending': 'ட்ரெண்டிங்',
  'friends.follow_option_only_follow': 'பின்தொடர்',
  'friends.follow_option_friends': 'நண்பர்கள்',
  'watch.like': 'விருப்பம்',
  'watch.views_short': '{n} பார்வைகள்',
  'shorts.empty.title': 'இன்னும் ஷார்ட்ஸ் இல்லை',
  'shorts.empty.subtitle': 'பிரிவைத் தொடங்க ஒரு குறு வீடியோவைப் பதிவேற்றவும்.',
  'shorts.share': 'பகிர்',
  'auth.continue_google': 'Google உடன் தொடரவும்',
  'upload.is_premium': 'பிரீமியம்',
  'upload.price': 'விலை (€)',
  'upload.err_select': 'வீடியோவைத் தேர்ந்தெடுக்கவும்',
  'profile.upload_btn': 'வீடியோ பதிவேற்று',
  'profile.tab_videos': 'என் வீடியோக்கள் ({n})',
  'profile.tab_history': 'வரலாறு',
  'profile.tab_recos': 'பரிந்துரைகள்',
  'profile.no_videos': 'நீங்கள் இன்னும் வீடியோக்களைப் பதிவேற்றவில்லை.',
  'profile.no_history': 'நீங்கள் இன்னும் வீடியோக்களைப் பார்க்கவில்லை.',
  'profile.no_recos': 'பரிந்துரைகளைப் பெற சில வீடியோக்களைப் பாருங்கள்.',
  'profile.likes': 'விருப்பங்கள்',
  'profile.views': 'பார்வைகள்',
  'wallet.title': 'வாலட்',
  'wallet.rate_label': 'விகிதம்',
  'wallet.min_label': 'குறைந்தபட்ச திரும்பப்பெறுதல்',
  'wallet.amount_label': 'திரும்பப்பெற வேண்டிய தொகை',
  'wallet.withdraw_btn': 'திரும்பப்பெறுதல் கோரிக்கை',
  'wallet.history_title': 'திரும்பப்பெறுதல் வரலாறு',
  'wallet.success': 'கோரிக்கை உருவாக்கப்பட்டது',
  'wallet.bad_amount': 'தவறான தொகை',
  'wallet.per_view': '{rate} {cur}/பார்வை',
  'admin.title': 'நிர்வாகம்',
  'admin.stats.users': 'பயனர்கள்',
  'admin.stats.videos': 'வீடியோக்கள்',
  'admin.stats.shorts': 'ஷார்ட்ஸ்',
  'admin.stats.views': 'பார்வைகள்',
  'admin.tab.videos': 'வீடியோக்கள்',
  'admin.tab.ads': 'விளம்பரங்கள்',
  'admin.tab.users': 'பயனர்கள்',
  'admin.tab.withdrawals': 'திரும்பப்பெறுதல்கள்',
  'admin.tab.config': 'அமைப்புகள்',
  'admin.tab.translations': 'மொழிபெயர்ப்புகள்',
  'tbl.title': 'தலைப்பு',
  'tbl.creator': 'உருவாக்குநர்',
  'tbl.category': 'பிரிவு',
  'tbl.type': 'வகை',
  'tbl.views': 'பார்வைகள்',
  'tbl.likes': 'விருப்பங்கள்',
  'tbl.status': 'நிலை',
  'tbl.actions': 'செயல்கள்',
  'tbl.placement': 'இடம்',
  'tbl.advertiser': 'விளம்பரதாரர்',
  'tbl.impressions': 'பதிவுகள்',
  'tbl.clicks': 'கிளிக்',
  'tbl.active': 'செயலில்',
  'tbl.name': 'பெயர்',
  'tbl.email': 'மின்னஞ்சல்',
  'tbl.role': 'பங்கு',
  'tbl.wallet': 'வாலட்',
  'tbl.amount': 'தொகை',
  'tbl.date': 'தேதி',
  'tbl.user': 'பயனர்',
  'video.video': 'வீடியோ',
  'video.short': 'ஷார்ட்',
  'action.show': 'வெளியிடு',
  'action.hide': 'மறை',
  'action.delete_confirm_video': 'வீடியோவை நீக்கவா?',
  'ad.create_h': 'விளம்பரம் உருவாக்கு',
  'ad.title_label': 'தலைப்பு',
  'ad.image_label': 'பட URL',
  'ad.target_label': 'இலக்கு URL',
  'ad.advertiser_label': 'விளம்பரதாரர்',
  'ad.placement_label': 'இடம்',
  'ad.placement.banner': 'பேனர் (தளம்)',
  'ad.placement.preroll': 'பிரீ-ரோல் (வீடியோவுக்கு முன்)',
  'ad.placement.overlay': 'ஓவர்லே (வீடியோவுக்குள்)',
  'ad.active': 'செயலில்',
  'ad.create_btn': 'உருவாக்கு',
  'ad.success_create': 'விளம்பரம் உருவாக்கப்பட்டது',
  'ad.delete_confirm': 'விளம்பரத்தை நீக்கவா?',
  'users.make_admin': 'நிர்வாகியாக்கு',
  'users.remove_admin': 'நிர்வாகத்தை நீக்கு',
  'wd.approve': 'அங்கீகரி',
  'wd.reject': 'நிராகரி',
  'wd.mark_paid': 'செலுத்தியதாகக் குறி',
  'wd.empty': 'கோரிக்கைகள் இல்லை',
  'cfg.title': 'கட்டண அமைப்புகள்',
  'cfg.rate_label': 'ஒரு பார்வைக்கு கட்டணம் ({cur})',
  'cfg.min_label': 'குறைந்தபட்ச திரும்பப்பெறுதல் ({cur})',
  'cfg.currency': 'நாணயம்',
  'cfg.save': 'சேமி',
  'cfg.saved': 'அமைப்புகள் சேமிக்கப்பட்டன',
  'trans.title': 'மொழிகள் & மொழிபெயர்ப்புகள்',
  'trans.intro': 'எந்த மொழி குறியீட்டிற்கும் (எ.கா. ja, pt, zh) மொழிபெயர்ப்புகளுடன் JSON கோப்பைப் பதிவேற்றவும். கோப்பில் key → string என்ற தட்டை வரைபடம் இருக்க வேண்டும்.',
  'trans.code_label': 'மொழி குறியீடு (எ.கா. ja, pt-BR, zh)',
  'trans.name_label': 'காட்சிப் பெயர் (அந்த மொழியில்)',
  'trans.file_label': 'மொழிபெயர்ப்பு JSON கோப்பு',
  'trans.upload': 'பதிவேற்று',
  'trans.uploaded': 'மொழிபெயர்ப்புகள் சேமிக்கப்பட்டன',
  'trans.delete': 'நீக்கு',
  'trans.delete_confirm': 'இந்த மொழியை நீக்கவா?',
  'trans.builtin': 'உள்ளமைந்த',
  'trans.custom': 'தனிப்பயன்',
  'trans.empty_custom': 'இன்னும் தனிப்பயன் மொழிகள் இல்லை.',
  'common.cancel': 'ரத்து',
  'common.loading': 'ஏற்றுகிறது...',
  'common.too_fast': 'மிக வேகமாக, தயவுசெய்து காத்திருக்கவும்',
  'time.few_seconds': 'சில வினாடிகளுக்கு முன்',
  'time.min': '{n} நிமிடங்களுக்கு முன்',
  'time.h': '{n} மணி நேரத்திற்கு முன்',
  'time.d': '{n} நாட்களுக்கு முன்',
  'time.w': '{n} வாரங்களுக்கு முன்',
  'time.mo': '{n} மாதங்களுக்கு முன்',
  'time.y': '{n} ஆண்டுகளுக்கு முன்',
  'brand.tagline': 'குறும் வீடியோக்கள். உண்மையான உருவாக்குநர்கள்.',
  'live.section': 'நேரலை',
  'live.start': 'நேரலையைத் தொடங்கு',
  'live.end': 'நேரலையை முடி',
  'live.join': 'நேரலையில் சேர்',
  'live.chat_placeholder': 'ஒரு செய்தியைத் தட்டச்சு செய்யவும்...',
  'live.diamond': 'வைரம்',
  'live.buy_access': 'அணுகலை வாங்கு',
  'live.save_recording': 'பதிவை சேமி',
};
